import { Spinner, Toggle } from '@/components/ui'
import DataContainer from '../../common/DataContainer'
import { formatDate, formatPrice } from '@/utils/formatters'
import { useBienContext } from "@/features/biens/BienContext"
import Assurance from './Assurance'

export default () => {
  const { bien, loading } = useBienContext()
  const location = bien.location

  const mandat = bien.mandats.find( m => m.type_mandat === 'location')

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">

      <div className="flex flex-col h-full">
        <h3 className="text-md font-semibold mb-2">
          Informations sur votre logement
        </h3>
        <div className={`w-full h-full bg-primary-100 p-4 rounded-none`}> 
          { loading && <Spinner /> }
          { !loading && <div className="grid grid-cols-1 gap-5"> 
              <div className="flex flex-col gap-2">
                <DataContainer label="Début de mandat" value={formatDate(mandat.date_signature)} />
                { mandat.date_fin && 
                  <DataContainer label="Fin de mandat" value={formatDate(mandat.date_fin)} />
                }

                { !mandat?.date_fin && !bien.appartient_a_immeuble && 
                  <Assurance 
                    assurance={bien.assurance_proprietaire}
                    date_dernier_releve={bien.assurance_proprietaire_date_dernier_releve}
                  />
                }
                { (!mandat?.date_fin && bien.prm_linky) && 
                    <DataContainer label="PRM Linky" value={bien.prm_linky} />
                }

                { !mandat?.date_fin &&
                  <div className="grid grid-cols-[13rem_1fr] items-center gap-2">
                    <div className="text-gray-600 whitespace-nowrap">Clé à l'agence :</div>
                    <Toggle.Display labelSuffix="" className="mb-0" value={bien.cle_dispo} />
                  </div>
                }

              </div>
            </div>
          }
        </div>
      </div>

      <div className="flex flex-col h-full">
        <h3 className="text-md font-semibold mb-2">
          Informations sur la location en cours
        </h3>
        <div className={`w-full h-full bg-primary-100 p-4 rounded-none`}> 
          { loading && <Spinner /> }
          {/* { !loading && !location && <div className="text-center">Aucune location</div> } */}
          { !loading && <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-2 gap-5"> 
            <div className="flex flex-col gap-2">
              { location?.prix_loyer > 0 && 
                <DataContainer label="Loyer HC" value={formatPrice(location?.prix_loyer)} />
              }
              { location?.montant_charges_total > 0 && 
                <DataContainer label="Charges" value={formatPrice(location?.montant_charges_total)} />
              }
              { (!mandat?.date_fin || location?.date_effet_bail) ? 
                  location?.date_fin_bail ? 
                    <div>
                      <DataContainer label="Loué du" value={formatDate(location?.date_effet_bail)} />
                      <DataContainer label="jusqu'au" value={formatDate(location?.date_fin_bail)} />
                    </div> :
                    <DataContainer label="Date effet bail" value={formatDate(location?.date_effet_bail)} /> :
                  null
              }

              { location?.montant_honoraires_ttc > 0 &&
                  <DataContainer label="Honoraires" value={formatPrice(location?.montant_honoraires_ttc)} />
              }

              { location?.montant_gli > 0 &&
                <DataContainer label="GLI" value={formatPrice(location?.montant_gli)} />
              }

              { location?.montant_frais_entree > 0 &&
                <DataContainer label="Frais d'entrée" value={formatPrice(location?.montant_frais_entree)} />
              }
            </div>
          </div> }
        </div>
      </div>
    </div>
  )
}